import { useCallback, useContext } from 'react';

import { OrderFilters } from 'types';

import { useQueryFilters } from './use-query-filters.hook';
import { WhiteTriangleContext } from './use-white-triangle-context';

export const useWhiteTriangle = () => {
  const { filters, setFilters } = useQueryFilters<OrderFilters>();

  const setRequisitesIdFilter = useCallback(
    (id: string) => setFilters({ ...filters, requisitesId: id }),
    [filters, setFilters],
  );

  return {
    ...useContext(WhiteTriangleContext),
    setRequisitesIdFilter,
    filters,
  };
};
